
export function ContactInfoSection() {
  const contactMethods = [
    {
      icon: 'ri-mail-line',
      title: 'Email Us',
      description: 'Get in touch via email',
      contact: 'hello@driscop.co.uk',
      action: 'mailto:hello@driscop.co.uk'
    },
    {
      icon: 'ri-phone-line',
      title: 'Call Us',
      description: 'Speak to our team directly',
      contact: '+44 161 123 4567',
      action: 'tel:+441611234567'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Visit Us',
      description: 'Our Manchester office',
      contact: 'Manchester, UK',
      action: '#'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-black to-gray-900">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Other Ways to Reach Us
            </h2>
            <p className="text-xl text-gray-400">
              Choose the method that works best for you
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {contactMethods.map((method, index) => (
              <div key={index} className="bg-gray-800/50 p-8 rounded-xl text-center border border-gray-700">
                <div className="w-16 h-16 bg-blue-500/200/20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${method.icon} text-blue-400 text-2xl`}></i>
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">
                  {method.title}
                </h3>
                <p className="text-gray-400 mb-4">
                  {method.description}
                </p>
                <a
                  href={method.action}
                  className="text-blue-400 hover:text-blue-700 font-medium cursor-pointer"
                >
                  {method.contact}
                </a>
              </div>
            ))}
          </div>

          <div className="bg-gray-800/50 p-8 rounded-xl border border-gray-700">
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl font-semibold text-white mb-4">
                  Office Hours & Support
                </h3>
                <div className="space-y-4">
                  <div className="flex items-center">
                    <i className="ri-time-line text-blue-400 mr-3"></i>
                    <div>
                      <div className="font-medium text-white">Business Hours</div>
                      <div className="text-gray-400">Monday - Friday: 9:00 AM - 6:00 PM GMT</div>
                    </div>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-customer-service-line text-blue-400 mr-3"></i>
                    <div>
                      <div className="font-medium text-white">Emergency Support</div>
                      <div className="text-gray-400">24/7 for Enterprise customers</div>
                    </div>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-shield-check-line text-blue-400 mr-3"></i>
                    <div>
                      <div className="font-medium text-white">Response Time</div>
                      <div className="text-gray-400">Within 24 hours for all inquiries</div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="text-center lg:text-right">
                <div className="inline-block bg-blue-500/20 p-6 rounded-xl">
                  <h4 className="font-semibold text-white mb-2">
                    Need Immediate Help?
                  </h4>
                  <p className="text-gray-400 mb-4">
                    Start your free trial and get instant protection
                  </p>
                  <button className="bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                    Start Free Trial
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
